import {createSlice} from "@reduxjs/toolkit";
import config from "../../config";

const product = createSlice({
	name: "product",
	initialState: {
		loading: false,
        error: null,
		items: [],
		filter:{
			page : 1,
			limit : config.api.limit,
		},
		pagination : {
			page : 1,
			limit : config.api.limit,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id === action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const productActions = product.actions;
//Reducers
export const productReducer = product.reducer;
//Selectors
export const productItemsSelector = (state) => state.product.items;
export const productLoadingSelector = (state) => state.product.loading;
export const productErrorSelector = (state) => state.product.error;
export const productFilterSelector = (state) => state.product.filter;
export const productPaginationSelector = (state) => state.product.pagination;
